<template>
    <page>
        <module>
            <view-list ref="view" work-type="16" selector :view-config="auth('b_asset_repair_viewmanage')">
                <template #search>
                    <m-search ref="search" :default-data="defaultSearchData">
                        <m-search-item label="单据编号">
                            <c-input name="document_number"></c-input>
                        </m-search-item>
                        <m-search-item label="资产编号">
                            <c-input name="asset_code"></c-input>
                        </m-search-item>
                        <m-search-item label="送修人">
                            <c-input name="sender_user_name"></c-input>
                        </m-search-item>
                    </m-search>
                </template>

                <template #document_number="{data}">
                    <c-link @click="globalDialog('assetRepairRecordDetail', {props: {id: data.id}})">{{data.document_number}}</c-link>
                </template>

                <template #operate="{data}">
                    <c-button color="main" v-if="auth('b_asset_repair_create')" prepend-icon="tf-add" @click="$refs.repairEdit.open()">新增维修记录</c-button>
                    <c-button v-if="auth('b_asset_repair_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
                </template>

                <template #status="{data}">
                    <c-state dict="repairStatusDic" :value="data.status"></c-state>
                </template>

                <c-table-column type="button" label="操作" width="220" button-limit="3">
                    <template #default="{data}">
                        <c-table-button v-if="auth('b_asset_repair_view')" icon="tf-view" @click="globalDialog('assetRepairRecordDetail', {props: {id: data.id}})">查看</c-table-button>
                        <c-table-button v-if="auth('b_asset_repair_edit')" icon="tf-edit" :disabled="data.status==2" @click="$refs.repairEdit.open(data)">编辑</c-table-button>
                        <c-table-button v-if="auth('b_asset_repair_finish')" :disabled="data.status==2" icon="tf-check" @click="finishRepair(data)">完成维修</c-table-button>
                        <c-table-button v-if="auth('b_asset_repair_print')" icon="tf-print" @click="$refs.view.exportByTemplate(data.id)">打印</c-table-button>
                        <c-table-button v-if="auth('b_asset_repair_remove')" icon="tf-delete" :disabled="data.status==2" @click="removeRecord(data)">删除</c-table-button>
                    </template>
                </c-table-column>
            </view-list>

            <asset-repair-record-edit ref="repairEdit" @resolve="$refs.view.$refs.list.update()"></asset-repair-record-edit>
            <asset-repair-finish-dialog ref="repairFinish" @resolve="$refs.view.$refs.list.update()"></asset-repair-finish-dialog>
        </module>
    </page>
</template>

<script>
import {mapState} from "vuex";
import AssetRepairRecordEdit from "@/pages/asset/asset_repair_record_edit.vue";
import AssetRepairFinishDialog from "@/pages/asset/asset_repair_record_finish.vue";

export default {
    components: {AssetRepairRecordEdit, AssetRepairFinishDialog},
    computed: {
        ...mapState(['repairStatusDic'])
    },
    data() {
        return {
            defaultSearchData: {
                record_status: []
            }
        }
    },
    methods: {
        removeRecord(data) {
            this.$confirm({
                message: '确认删除维修记录【' + (data.document_number || data.id) + '】？删除后不可恢复',
                buttonName: '确定',
                cancelButton: true,
                resolve: () => {
                    this.request({
                        url: '/asset_repair_record/delete',
                        data: {
                            id: data.id
                        },
                        loading: true,
                        success: () => {
                            this.$message({message: '删除成功', type: 'success'});
                            this.$refs.view.$refs.list.update();
                        }
                    });
                },
                cancel: () => {}
            });
        },
        finishRepair(data) {
            this.$refs.repairFinish.open(data);
        }
    }
}
</script>
